export default __webpack_public_path__ + "static/media/010204202135100.024dccfb.png";